// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    add: 'Ajouter',
    AddMoreSpace: 'Mettre à niveau maintenant',
    all_projects_label: 'Tous les projets',
    archive_action_text: 'Archiver',
    Attach: 'Joindre un fichier',
    attach_file_image: 'Joindre un fichier ou une image',
    btn_reload: 'Recharger',
    Cancel: 'Annuler',
    change: 'Modifier',
    Close: 'Fermer',
    completeActivityConfirm: 'Vous avez indiqué que cette activité est 100% terminée. Voulez-vous terminer l\'activité? Appuyez sur \'OK\' pour modifier le statut, ou sur \'Annuler\' dans le cas contraire.',
    completeActivityTitle: 'Souhaitez-vous terminer cette activité ?',
    completeProjectConfirm: 'Vous avez indiqué que ce projet est 100% terminé. Voulez-vous terminer ce projet ? Appuyez sur \'OK\' pour modifier le statut.',
    completeProjectTitle: 'Souhaitez-vous terminer ce projet ?',
    confirmCompleteActivityParents: 'La fin de cette sous-activité n\'en laissera aucune ouverte sous son activité parent. Voulez-vous marquer l\'activité parent comme terminée?  Notez que s\'il n\'y a plus aucune activité ouverte sur le projet, il sera marqué comme étant terminé également.',
    confirmCompleteActivityParentsTitle: 'Définir le statut de {0} comme terminé ?',
    continue: 'Continuer',
    copyLink: 'Copier le lien',
    DayAbbreviation: 'j',
    DayPluralFormat: '1#jour#jours',
    DayPluralFormatTemplate: '1#{0} jour#{0} jours',
    Delete: 'Supprimer',
    delete_confirmation: 'Cette action ne peut pas être annulée.',
    delete_permanently_text: 'Supprimer définitivement',
    disabled: 'Désactivé',
    disabledUserText: '(désactivé)',
    Download: 'Télécharger',
    Duplicate: 'Dupliquer',
    Edit: 'Modifier',
    ElapsedTime_Ago: 'Il y a {0}',
    enabled: 'Activé',
    Entity_Category: 'Catégorie',
    Entity_Customer: 'Client',
    Entity_Issue: 'Problème',
    Entity_Portfolio: 'Portefeuille',
    Entity_Priority: 'Priorité',
    Entity_Project: 'Projet',
    Entity_ProjectStatus: 'Statut',
    Entity_Request: 'Requête',
    Entity_Task: 'Tâche',
    Entity_TaskStatus: 'Statut',
    Entity_User: 'Utilisateur',
    Error_CantFindObjectTemplate: 'L\'opération n\'a pas pu être terminée pour les raison(s) suivante(s): élément (type : {entityName}, ID: {objectKey}) n\'a pas été trouvé dans la base de données.  Cela peut être dû à la suppression de, ou de ne pas avoir l\'autorisation d\'afficher l\'élément. Consulter votre administrateur {brandName} pour les causes possibles.',
    error_notFullyCompleted: 'Un objet ou un utilisateur impliqué a été supprimé ou des autorisations d\'accès ont été révoquées par un autre utilisateur.',
    ErrorFileSizeLimit: 'Le téléversement du fichier {0} n\'a pas pu être terminé, car vous ne pouvez pas téléverser des fichiers d\'une taille supérieure à ∼ {1} Go',
    ErrorUploadExceededText: 'Le téléversement du fichier {0} n\'a pas pu être terminé, car votre compte est à court d\'espace.',
    ErrorUploadText: 'Le téléversement du fichier {0} a rencontré une erreur inconnue et n\'a pas pu être terminé. Veuillez répéter le processus de téléversement.',
    ErrorUploadTitle: 'Erreur lors du téléversement du fichier.',
    exported: 'Exporté',
    exporting: 'Exportation',
    failed: 'Échec',
    help: 'Aide',
    HourAbbreviation: 'h',
    HourPluralFormat: '1#heure#heures',
    HourPluralFormatTemplate: '1#{0} Heure#{0} Heures',
    HyperLinkTooltip: 'CTRL+Clic pour suivre le lien',
    items_selected_plural: '1#{0} élément sélectionné#{0} éléments sélectionnés',
    madeBy: 'Alimenté par',
    MinuteAbbreviation: 'm',
    MinutePluralFormat: '1#{0} min#{0} min',
    more_counter_text: 'et {0} de plus',
    next: 'Suivant',
    no_items_selected: 'Aucun élément sélectionné',
    None_Text: 'Aucun',
    Not_set: 'Non défini',
    Ok: 'OK',
    open_details_new_tab: 'Ouvrir les détails dans un nouvel onglet',
    OpeningWindow: 'Ouverture...',
    OpenOriginal: 'Ouvrir l\'original',
    OperationError_Title: 'L\'opération n\'a pas pu être terminée',
    parentActivity: 'activité parente',
    Remove: 'Supprimer',
    Reset: 'Réinitialiser',
    Save: 'Enregistrer',
    saved: 'Enregistré',
    saving: 'Enregistrement',
    Search: 'Recherche',
    setCompleted: 'Définir comme terminé',
    show_less_label: 'Afficher moins',
    show_more_label: 'Afficher plus',
    space_exceeded_description: 'L\'espace de stockage disponible est insuffisant pour stocker les fichiers.',
    space_exceeded_title: 'Le stockage est plein',
    summary: 'Sommaire',
    timer_text: '1#{0} seconde#{0} secondes',
    title_notFullyCompleted: 'L\'opération n\'a pas pu être réalisée partiellement ou totalement',
    title_reload: 'Veuillez recharger la page',
    total: 'Total',
    turn_off: 'Désactiver',
    type: 'Type',
    Type_for_search: 'Tapez pour rechercher',
    Type_for_search_or_add: 'Tapez pour rechercher ou ajouter ',
    upload: 'Téléverser',
    WebPushNotificationPanelLink: 'activer les notifications de bureau.',
    WebPushNotificationPanelText: '{brandName} a besoin de votre autorisation pour ',
    you_user_text: 'vous',
};
